import { styled } from '@linaria/react';

import { fonts, semantic, space } from '../../theme/tokens';

export const Wrapper = styled.div`
  border-bottom: 1px solid ${semantic.border.default};
`;

export const Trigger = styled.button`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${space['space-300']};
  padding: ${space['space-400']} 0;
  background: none;
  border: none;
  cursor: pointer;
  color: ${semantic.text.primary};
  font-family: ${fonts.body};
  font-size: ${fonts.size.md};
  font-weight: ${fonts.weight.medium};
`;

export const TriggerLeft = styled.span`
  display: inline-flex;
  align-items: center;
  gap: ${space['space-200']};

  & svg {
    transition: transform 0.2s ease;
  }

  &[data-open='true'] svg {
    transform: rotate(180deg);
  }
`;

export const Content = styled.div`
  padding-bottom: ${space['space-400']};
`;
